import React from 'react';
import { AppLayout } from '@/components/layout/AppLayout';
import { AppHeader } from '@/components/layout/AppHeader';
import { Footer } from '@/components/layout/Footer';
import GenerationsList from '@/components/generations/GenerationsList';

const MyGenerations: React.FC = () => {
  return (
    <AppLayout>
      <AppHeader
        title="My Generations"
        subtitle="View and manage all your created surveys and conversation templates in one place."
        breadcrumbs={[
          { label: 'My Generations' }
        ]}
      />
      
      <div className="container mx-auto px-4 py-8">
        <GenerationsList />
      </div>
      
      <Footer />
    </AppLayout>
  );
};

export default MyGenerations;